import React from 'react';
import { Badge } from '@/components/ui/badge';
import { BookOpen } from 'lucide-react';

export const ConfidenceBadge = ({ value, testid }) => {
  const pct = Math.round((value || 0) * 100);
  const cls = pct >= 85
    ? 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30'
    : pct >= 60
      ? 'bg-amber-500/15 text-amber-300 border-amber-500/30'
      : 'bg-red-500/15 text-red-300 border-red-500/30';
  return <Badge variant="outline" className={cls} data-testid={testid}>Confianza {pct}%</Badge>;
};

export const SimpleBadge = ({ simple }) => (
  <Badge variant="outline" className={simple ? 'bg-sky-500/15 text-sky-300 border-sky-500/30' : 'bg-slate-500/15 text-slate-300 border-slate-500/30'}>
    {simple ? 'Sencillo' : 'Requiere revisión'}
  </Badge>
);

export const SUGGESTION_STATUS = {
  draft: { label: 'Borrador', cls: 'bg-amber-500/15 text-amber-300 border-amber-500/30' },
  auto_sent: { label: 'Auto-respondido', cls: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30' },
  sent: { label: 'Enviado por agente', cls: 'bg-sky-500/15 text-sky-300 border-sky-500/30' },
  discarded: { label: 'Descartado', cls: 'bg-slate-500/15 text-slate-300 border-slate-500/30' },
  error: { label: 'Error', cls: 'bg-red-500/15 text-red-300 border-red-500/30' },
};

export const StatusPill = ({ status }) => {
  const s = SUGGESTION_STATUS[status] || { label: status, cls: '' };
  return <Badge variant="outline" className={s.cls} data-testid={`ai-status-${status}`}>{s.label}</Badge>;
};

export const AiMeta = ({ result }) => (
  <div className="space-y-2">
    <div className="flex flex-wrap items-center gap-2">
      <ConfidenceBadge value={result.confidence} testid="ai-confidence" />
      <SimpleBadge simple={result.is_simple} />
      {result.category && <span className="text-xs text-[hsl(var(--muted-foreground))]">{result.category}</span>}
    </div>
    {result.reasoning && <p className="text-xs text-[hsl(var(--muted-foreground))] italic" data-testid="ai-reasoning">{result.reasoning}</p>}
    {result.kb_used?.length > 0 && (
      <div className="flex flex-wrap gap-1.5 text-xs">
        <BookOpen className="w-3.5 h-3.5 text-[hsl(var(--primary))]" />
        {result.kb_used.map((k) => <span key={k.id} className="px-1.5 py-0.5 rounded bg-[hsl(var(--muted))]/40">{k.title}</span>)}
      </div>
    )}
  </div>
);
